export default __webpack_public_path__ + "static/media/10.b9958e11.png";